<template>
  <div class="make-room">
      <h1>
        Make Room
      </h1>
      <section class="input-section">
        <div>
          Title: <input type="text" v-model="newRoom.title" />
        </div>
        <div class="red" v-if="notAlphaNumeric">not alpha numeric or _ or -</div>
        <!-- <div class="red" v-if="msgs.find(i => i.id === 503)">
          {{ msgs.find(i => i.id === 503).msg }}
        </div> -->
      </section>

      <section class="input-section">
        <div>
          Desc: <input type="text" v-model="newRoom.desc" />
        </div>
      </section>

      <section class="input-section">
        <div>
          Hide from Search Result: <input type="checkbox" v-model="newRoom.hideFromSearchResult" />
        </div>
      </section>

      <section class="input-section">
      <div>
        Enable admin features: <input type="checkbox" v-model="newRoom.enableRoomAdminFeatures" />
      </div>
      </section>
      <div v-show="newRoom.enableRoomAdminFeatures">
          <div>
            To enable room owner badge, delete room option, mute student and message delete features, student participation statistics, like comment button, a choice between chatroom vs. voting mode, please set your room's password.
          </div>
          <div>
            Room Admin password: <br/> <input type="password" v-model="newRoom.roomAdminPassword" />
          </div>
          <div>
            Password Restore Question: <br/> <input type="text" placeholder="What is the name of your pet?" v-model="newRoom.roomAdminPasswordRecoveryQuestion" />
          </div>
          <div>
            Password Restore Answer: <br/> <input type="text" placeholder="Happy Hamster" v-model="newRoom.roomAdminPasswordRecoveryAnswer" />
          </div>
      </div>

      <div>
        Enable entry Password: <input type="checkbox" v-model="newRoom.enableRoomEntryPassword" />
      </div>

      <div v-show="newRoom.enableRoomEntryPassword">
        <div>
          Room Entry Password:
          <input type="password" v-model="newRoom.roomEntryPassword" />
        </div>
      </div>
      <div>
        <button v-if="!loading" @click="createRoom">
          {{ cta }}
        </button>
        <button disabled="disabled" v-if="loading">
          Loading...
        </button>

        <div :key="msg.id" v-for="msg in msgs" class="red">{{ msg.msg }}</div>
      </div>

      <!-- <div v-if="$debug">
        <h2>new room</h2>
        <pre>{{ newRoom }}</pre>
        <h2>result</h2>
        <pre>{{ result }}</pre>
      </div> -->
  </div>
</template>

<script>
import { API } from '@/yoteach2-gui/parts/index.js'
import _ from 'lodash'
import validator from 'validator'

export default {
  data () {
    let template = {
      title: '',
      desc: '',

      hideFromSearchResult: false,

      enableRoomAdminFeatures: false,
      roomAdminPassword: '',
      roomAdminPasswordRecoveryQuestion: '',
      roomAdminPasswordRecoveryAnswer: '',

      enableRoomEntryPassword: false,
      roomEntryPassword: '',

      sortMethod: 'chat',

      adminUUIDs: [],
      mutedUUIDs: []
    }
    return {
      notAlphaNumeric: false,
      loading: false,
      template,
      newRoom: JSON.parse(JSON.stringify(template)),
      cta: 'create room',
      result: false,
      msgs: []
    }
  },
  computed: {
    newName () {
      return this.newRoom.title
    }
  },
  watch: {
    newName () {
      this.notAlphaNumeric = this.notOkayTitleString(this.newName)
      this.checkRoomNameTaken({ title: this.newName || '' })
    }
  },
  methods: {
    checkRoomNameTaken: _.debounce(function ({ title }) {
      this.checkUniqueTitle({ title })
    }, 300),
    checkUniqueTitle ({ title }) {
      return API.checkRoomNameTaken({
        title
      }).then(() => {
        var idx = this.msgs.findIndex(m => m.id === 503)
        if (idx !== -1) {
          this.msgs.splice(idx, 1)
        }
        return true
      }, () => {
        if (this.msgs.findIndex(m => m.id === 503) === -1) {
          this.msgs.push({ id: 503, msg: 'Room name is taken' })
        }
        return false
      })
    },
    reset () {
      this.newRoom = JSON.parse(JSON.stringify(this.template))
    },
    notOkayTitleString (v) {
      /* eslint-disable */
      return !(
        validator.isAlphanumeric(v)
        || (
             !(validator.contains(v, '/'))
          && !(validator.contains(v, `\\`))
          && !(validator.contains(v, `*`))
          && !(validator.contains(v, `!`))
          && !(validator.contains(v, `#`))
          && !(validator.contains(v, `&`))
          && !(validator.contains(v, `?`))
          && !(validator.contains(v, `>`))
          && !(validator.contains(v, `<`))
          && !(validator.contains(v, `{`))
          && !(validator.contains(v, `}`))
          && !(validator.contains(v, `[`))
          && !(validator.contains(v, `]`))
        )
      )
      /* eslint-enable */
    },
    async createRoom () {
      let data = this.newRoom
      this.loading = true
      this.msgs = [
      ]

      if ((data.title + '').trim() === '') {
        if (this.msgs.findIndex(m => m.id === 0) === -1) {
          this.msgs.push({ id: 0, msg: 'Needs to fill in room title' })
        }
      }

      if (data.enableRoomAdminFeatures && (data.roomAdminPassword + '').trim() === '') {
        if (this.msgs.findIndex(m => m.id === 1) === -1) {
          this.msgs.push({ id: 1, msg: 'Needs to fill in room admin password.' })
        }
      }
      if (data.enableRoomEntryPassword && (data.roomEntryPassword + '').trim() === '') {
        if (this.msgs.findIndex(m => m.id === 2) === -1) {
          this.msgs.push({ id: 2, msg: 'Needs to fill in room entry password.' })
        }
      }

      if (this.notOkayTitleString(data.title)) {
        if (this.msgs.findIndex(m => m.id === 3) === -1) {
          this.msgs.push({ id: 3, msg: 'Room title only accept alpha numerical, - and _' })
        }
      }

      let isUnique = await this.checkUniqueTitle({ title: this.newName })

      if (this.msgs.length > 0 || !isUnique) {
        this.loading = false
        return
      }

      API.createRoom({ ...this.newRoom })
        .then((resp) => {
          this.result = resp.data
          // this.$router.push(`/room/${this.result._id}`)
        }, (resp) => {
          this.msgs.push({ id: 500, msg: 'Cannot create room' })
        })
        .then(() => {
          this.newRoom = JSON.parse(JSON.stringify(this.template))
          this.loading = false
        }, () => {
          this.loading = false
        })
    }
  }
}

</script>

<style scoped>
.red{
  color:red;
}
.input-section{
  margin-top: 10px;
}
</style>
